const validate = (values) => {
  const errors = {};
  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.duration) {
    errors.duration = 'Required';
  } else if (parseInt(values.duration, 10) < 1) {
    errors.duration = { _error: 'Duration need to be at least 1 minute long.' };
  }
  return errors;
};

export default validate;
